import {Link} from 'react-router-dom'


function Navigation(){
    return (
        <nav className="app-nav">
            <Link to="/">
            <button>Home</button></Link>&nbsp;

            <Link to="/contact-page">
            <button>Contact Me</button></Link>&nbsp;
            
            <Link to="/work-examples-page">
            <button>Work Examples</button></Link>
            
        </nav>
    )
}

export default Navigation;
